
<script setup>

  import AudioPlayer from '../components/audio-player.vue';

  import audio from '../audio/shirley-*.mp3';

  import track from '../audio/shirley-*.vtt';

  const players = [ {

    id: 1,

    title: 'More Than Just a Place to Picnic'

  }, {

    id: 2,

    title: 'Evenings at the Lodge'

  } ].map( obj => ( { ...obj, audio: audio[ obj.id ], track: track[ obj.id ] } ) );

</script>

<template>

  <p>Visitor to Lewis Mountain</p>

  <div v-for="{ audio, track, title } in players" class="mt-6" >

    <h4 class="font-bold">{{ title }}</h4>

    <AudioPlayer class="mt-4" :src="audio" :track="track" />

  </div>

  <div class="mt-8 text-xs italic">

    Source: NY-VA Club Group Interview, Part of the Lewis Mountain Cultural Landscape Report, August 30, 2022.

  </div>

</template>
